import React, { FC } from 'react';
import Loader from '../../Loader/loader';
import { ActionsButtonProps } from './ConfirmationModalInterface';
import { ActionButtonContainer, ActionButtonStyled } from './styled';

const ActionsButton: FC<ActionsButtonProps> = ({
    handleClickCancel,
    handleClickConfirm,
    labelCancel,
    labelConfirm,
    isLoading = false,
}) => (
    <ActionButtonContainer>
        <ActionButtonStyled
            disabled={isLoading}
            lighten={1}
            onClick={handleClickCancel}
            variant="text"
            disableRipple
        >
            {labelCancel}
        </ActionButtonStyled>
        <ActionButtonStyled
            disabled={isLoading}
            onClick={handleClickConfirm}
            variant="text"
            default
            disableRipple
        >
            {isLoading ? <Loader size={20} /> : labelConfirm}
        </ActionButtonStyled>
    </ActionButtonContainer>
);

export default ActionsButton;
